import ComponentHeaderTwo from "common/ComponentHeaderTwo/ComponentHeaderTwo";
import { checkPrivileges } from "Helpers/CheckPrivileges";
import { getStationCreatePath } from "Helpers/stationRoutes";
import { useBusinessTabHeader } from "Helpers/useBusinessTabHeader";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as Business } from "../../assets/SideBarIcons/business.svg";
import { Box } from "@mui/material";
import StationListing from "pages/Station/StationListing";
import IntegrationTabs from "./Integrations/IntegrationTabs";
import { useSelector } from "react-redux";
import { selectUserInfo } from "features/user/userSlice";
// import ComponentSubheader from "common/ComponentHeaderTwo/ComponentSubheader";
// import { ReactComponent as Station } from "assets/SideBarIcons/station.svg";

export default function BusinessStations() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const params = useParams();
  const businessId = +(params as any)?.id;
  const loggedInUserData = useSelector(selectUserInfo);
  const canCreateStation =
    (loggedInUserData?.type === -1 || loggedInUserData?.type === 100) &&
    checkPrivileges("ROLE_STATION_CREATE");
  const { breadcrumbItems } = useBusinessTabHeader(params?.id, "stations");

  return (
    <>
      <ComponentHeaderTwo
        showBtn={true}
        showSaveBtn={false}
        onClick={() => navigate("/businesses")}
        heading={t("Businessses")}
        icon={<Business className="text-black w-[30px] h-[30px]" />}
        btnText={"back"}
        btnType={"back"}
        showCreateBtn={canCreateStation}
        createBtnText={"create"}
        onCreateClick={
          canCreateStation
            ? () => navigate(getStationCreatePath(businessId))
            : undefined
        }
        breadcrumbItems={breadcrumbItems}
      />
      <Box className={`flex`}>
        <IntegrationTabs params={params} selectedIndex={4} />
        <Box className="mt-[10px] flex-1 min-w-0">
          {/* <ComponentSubheader
            showBtn={true}
            showSaveBtn={false}
            onClick={() => navigate(getStationCreatePath(businessId))}
            heading={t("stations")}
            icon={<Station height={28} width={28} />}
            btnText={"create"}
            btnType={"create"}
            showCreateBtn={canCreateStation}
          /> */}
          <StationListing businessId={businessId} />
        </Box>
      </Box>
    </>
  );
}
